import footballImg from "@/assets/cc_img2_nfl.png";
import basketballImg from "@/assets/cc_img3_basketball.png";
import soccerImg from "@/assets/cc_img1_soccer.png";
import baseballImg from "@/assets/cc_img4_baseball.png";
import hockeyImg from "@/assets/cc_img5_hockey.png";
import collegeImg from "@/assets/cc_img6_college_football.png";
import golfImg from "@/assets/cc_img7_golf.png";
import tennisImg from "@/assets/cc_img8_tennis.png";

const moments = [
  { sport: "NFL Football", title: "Kick the game-winning field goal from the 30-yard line.", img: footballImg },
  { sport: "College Football", title: "Walk onto your school's field under Saturday night lights.", img: collegeImg },
  { sport: "Basketball", title: "Sink the free throw in a roaring championship arena.", img: basketballImg },
  { sport: "Soccer", title: "Take the penalty in front of a packed London stadium.", img: soccerImg },
  { sport: "Baseball", title: "Step into the batter's box with the game on the line.", img: baseballImg },
  { sport: "Hockey", title: "Take the final shootout attempt under arena lights.", img: hockeyImg },
  { sport: "Golf", title: "Sink the championship putt on the 18th green at sunset.", img: golfImg },
  { sport: "Tennis", title: "Serve for the match on center court at match point.", img: tennisImg },
];

export function Moments() {
  return (
    <section id="moments" className="relative py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">Signature Moments</p>
            <h2 className="font-display text-4xl sm:text-6xl leading-tight">
              The moments fans have <span className="text-gradient-ember">rehearsed in their heads</span> their entire lives.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {moments.map((m) => (
            <article key={m.sport} className="group">
              <div className="relative overflow-hidden rounded-sm border border-border/60 aspect-[4/3]">
                <img
                  src={m.img}
                  alt={m.title}
                  width={1280}
                  height={960}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 scan-lines opacity-30" />
              </div>
              <div className="pt-4">
                <div className="text-[11px] uppercase tracking-[0.3em] text-primary mb-2">{m.sport}</div>
                <h3 className="font-display text-lg leading-tight">{m.title}</h3>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-16 max-w-3xl text-sm uppercase tracking-[0.25em] text-muted-foreground leading-relaxed">
          Each sport creates a new content lane, customer segment, sponsorship opportunity,
          and future licensed <span className="text-primary">"moment pack."</span>
        </p>
      </div>
    </section>
  );
}
